import { configureStore } from "@reduxjs/toolkit"

import UIReducer from "./slices/ui-slice"

export const store = configureStore({
  reducer: {
    UI: UIReducer
  },
})
